export const trainingCatalog = [
  {
    id: 'digital-operations',
    title: 'Digital Operations 101',
    description: 'Master the core employee tools: request time off, report incidents, and keep leadership in the loop.',
    category: 'Systems',
    difficulty: 'Beginner',
    estimatedTime: '12 min',
    updatedAt: 'Dec 4, 2024',
    coverIcon: 'Cpu',
    accent: 'from-sky-500 via-blue-500 to-indigo-500',
    learningGoals: [
      'Navigate the manager and employee hubs with confidence',
      'Submit absence requests that auto-route for approval',
      'Capture accurate incident details in under a minute'
    ],
    videos: [
      {
        id: 'digital-operations-1',
        title: 'Kickoff & personalization',
        topic: 'Log in and tailor notifications so you never miss alerts.',
        duration: '0:52',
        youtubeId: 'dQw4w9WgXcQ',
      },
      {
        id: 'digital-operations-2',
        title: 'Dashboard overview',
        topic: 'Understand the daily cards, shift coverage, and urgent alerts.',
        duration: '0:47',
        youtubeId: 'kXYiU_JCYtU',
      },
      {
        id: 'digital-operations-3',
        title: 'Request an absence',
        topic: 'Send an absence request with supporting notes and attachments.',
        duration: '0:59',
        youtubeId: '3JZ_D3ELwOQ',
      },
      {
        id: 'digital-operations-4',
        title: 'Swap a shift',
        topic: 'Offer up a shift, share coverage details, and keep the calendar clean.',
        duration: '0:55',
        youtubeId: 'YQHsXMglC9A',
      },
      {
        id: 'digital-operations-5',
        title: 'Report an incident',
        topic: 'Capture the who, what, and where in less than 60 seconds.',
        duration: '0:48',
        youtubeId: '9bZkp7q19f0',
      },
      {
        id: 'digital-operations-6',
        title: 'Message the team',
        topic: 'Broadcast announcements or DM your shift lead.',
        duration: '0:54',
        youtubeId: 'fRh_vgS2dFE',
      },
      {
        id: 'digital-operations-7',
        title: 'Close the loop',
        topic: 'Confirm follow-ups and sync notes back to the manager hub.',
        duration: '0:51',
        youtubeId: 'e-ORhEE9VVg',
      },
    ],
  },
  {
    id: 'guest-experience-pro',
    title: 'Guest Experience Pro',
    description: 'Deliver five-star hospitality with confident table touches and fast recoveries.',
    category: 'Hospitality',
    difficulty: 'Intermediate',
    estimatedTime: '14 min',
    updatedAt: 'Nov 27, 2024',
    coverIcon: 'Sparkles',
    accent: 'from-amber-500 via-orange-500 to-rose-500',
    learningGoals: [
      'Spot moments to surprise and delight guests',
      'Escalate service recovery without leaving the floor',
      'Share daily wins with leadership for coaching'
    ],
    videos: [
      {
        id: 'guest-experience-1',
        title: 'Table touch plan',
        topic: 'Prep your talking points before the rush.',
        duration: '0:49',
        youtubeId: 'OPf0YbXqDm0',
      },
      {
        id: 'guest-experience-2',
        title: 'Memorable greetings',
        topic: 'Use names, eye contact, and personal cues.',
        duration: '0:51',
        youtubeId: 'CevxZvSJLk8',
      },
      {
        id: 'guest-experience-3',
        title: 'Reading the room',
        topic: 'Scan body language to prioritize visits.',
        duration: '0:46',
        youtubeId: 'uelHwf8o7_U',
      },
      {
        id: 'guest-experience-4',
        title: 'Recover a missed expectation',
        topic: 'Apologize, offer options, and log the follow-up.',
        duration: '0:58',
        youtubeId: 'hT_nvWreIhg',
      },
      {
        id: 'guest-experience-5',
        title: 'Escalate to a manager',
        topic: 'Flag high-risk scenarios in the app incident feed.',
        duration: '0:55',
        youtubeId: 'ktvTqknDobU',
      },
      {
        id: 'guest-experience-6',
        title: 'Celebrate wins',
        topic: 'Capture shout-outs right from the messaging tab.',
        duration: '0:53',
        youtubeId: 'YykjpeuMNEk',
      },
      {
        id: 'guest-experience-7',
        title: 'Close of shift recap',
        topic: 'Submit a quick recap so leaders can coach in real time.',
        duration: '0:47',
        youtubeId: 'kOkQ4T5WO9E',
      },
    ],
  },
  {
    id: 'kitchen-safety-suite',
    title: 'Kitchen Safety Suite',
    description: 'Keep the back of house safe with fast incident capture and proactive prevention.',
    category: 'Safety',
    difficulty: 'Advanced',
    estimatedTime: '15 min',
    updatedAt: 'Nov 12, 2024',
    coverIcon: 'ShieldAlert',
    accent: 'from-emerald-500 via-teal-500 to-slate-600',
    learningGoals: [
      'Identify line hazards before they become incidents',
      'Escalate serious injuries with the correct workflow',
      'Document root causes for faster follow-up actions'
    ],
    videos: [
      {
        id: 'kitchen-safety-1',
        title: 'Line walk checklist',
        topic: 'Start of shift hazard sweep and documentation.',
        duration: '0:52',
        youtubeId: 'EDwb9jOVRtU',
      },
      {
        id: 'kitchen-safety-2',
        title: 'PPE refresh',
        topic: 'Confirm gloves, cut sleeves, and slip mats are in place.',
        duration: '0:49',
        youtubeId: '7wtfhZwyrcc',
      },
      {
        id: 'kitchen-safety-3',
        title: 'Hot oil response',
        topic: 'Use the built-in flow to triage burns and notify leads.',
        duration: '0:58',
        youtubeId: 'rYEDA3JcQqw',
      },
      {
        id: 'kitchen-safety-4',
        title: 'Incident capture demo',
        topic: 'Record video, add photos, and attach witness notes.',
        duration: '0:55',
        youtubeId: 'LPgvNlrBfb0',
      },
      {
        id: 'kitchen-safety-5',
        title: 'Follow-up tasks',
        topic: 'Assign corrective actions inside the training hub.',
        duration: '0:47',
        youtubeId: 'Y66j_BUCBMY',
      },
      {
        id: 'kitchen-safety-6',
        title: 'OSHA export',
        topic: 'Generate a summary PDF straight from the report.',
        duration: '0:54',
        youtubeId: 'LsoLEjrDogU',
      },
      {
        id: 'kitchen-safety-7',
        title: 'Post-incident retro',
        topic: 'Host a 5-minute huddle and capture learnings.',
        duration: '0:59',
        youtubeId: 'HgzGwKwLmgM',
      },
    ],
  },
];

export const findTrainingById = (trainingId) =>
  trainingCatalog.find((training) => training.id === trainingId);
